import React, { useState } from "react";
import { Provider as PaperProvider, DefaultTheme } from "react-native-paper";
import { StyleSheet } from "react-native";
import { whiteColor, blackColor, greenBold } from "./../common/colors";

import routes from "./../routing/routes";

import WelcomeTest from "./../containers/WelcomeTest";
import SingleTest from "./../containers/SingleTest";

const modalTest = (props) => {
  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  //   useKeypress('Enter', () => {
  //     navigate();
  // });

  const navigate = () => {
    setIsTestRun(true);
  };
  const back = () => {
    props.navigation.navigate(routes.SignIn);
  };
  const close = () => {
    props.navigation.navigate(routes.Home);
  };

  const [isTestRun, setIsTestRun] = useState(false);
  return isTestRun ? (
    <SingleTest onClose={close} />
  ) : (
    <WelcomeTest navigate={navigate} onClose={close} />
  );
};
export default modalTest;

const styles = StyleSheet.create({
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 30,
    width: "100%",
    backgroundColor: whiteColor,
  },
  testRadio: {
    backgroundColor: whiteColor,
  },

  messagecontainer: {
    backgroundColor: whiteColor,
    width: "100%",
    height: "100%",
    alignItems: "center",
    display: "flex",
  },
  back: {
    paddingRight: 100,
    alignItems: "flex-end",
    display: "flex",
  },
  close: {
    paddingLeft: 200,
    paddingRight: 100,
  },
  icons: {
    textAlign: "center",
    paddingLeft: 100,
    paddingBottom: 24,
    display: "flex",
    flexDirection: "row",
  },
  container: {
    padding: 24,
    backgroundColor: whiteColor,
    width: "100%",
    alignItems: "center",
    paddingTop: 20,
  },
  title: {
    textAlign: "left",
    fontSize: 24,
    lineHeight: 16,
    letterSpacing: 1.25,
    paddingBottom: 24,
    paddingTop: 24,
    textTransform: "uppercase",
    marginRight: 185,
  },
  headermessage: {
    textAlign: "left",
    fontSize: 14,
    padding: 6,
    lineHeight: 18.75,
    letterSpacing: 1.25,
    paddingRight: 48,
    paddingLeft: 0,
    paddingTop: 24,
    paddingBottom: 24,
  },
  manywords: {
    alignItems: "stretch",
  },
  headertwomessage: {
    textAlign: "left",
    fontSize: 13,
    padding: 0,
    lineHeight: 20,
    letterSpacing: 1.25,
    paddingRight: 0,
    paddingLeft: 0,
    paddingBottom: 2,
    paddingTop: 24,
  },
  headerthreemessage: {
    textAlign: "left",
    fontSize: 13,
    padding: 0,
    lineHeight: 20,
    letterSpacing: 1.25,
    paddingRight: 0,
    paddingLeft: 0,
    paddingBottom: 2,
    paddingTop: 24,
  },
  textButton: {
    color: blackColor,
  },
  divider: {
    height: 10,
    backgroundColor: whiteColor,
  },
  buttonContainer: {
    alignItems: "center",
    display: "flex",
    paddingTop: 50,
    paddingLeft: 24,
    paddingRight: 24,
  },
  button: {
    borderWidth: 1,
    width: "100%",
    borderColor: blackColor,
  },
  greenbold: {
    color: greenBold,
    fontWeight: "700",
  },
});
